import { useInfiniteQuery } from "@tanstack/react-query";
import { getBeneficiaryRepository } from "@/infrastructure/di";
import { queryKeys } from "../queryKeys";

interface UseBeneficiaryDropdownSearchOptions {
  enabled?: boolean;
  pageSize?: number;
}

/**
 * Transport hook for the beneficiary dropdown: server-side searched, offset-paginated
 * infinite query. UI mapping/debounce live in the presentation-layer hook.
 */
export const useBeneficiaryDropdownSearch = (
  orgId: string,
  search: string,
  { enabled = true, pageSize = 20 }: UseBeneficiaryDropdownSearchOptions = {},
) => {
  return useInfiniteQuery({
    queryKey: queryKeys.beneficiaryDropdown.search(orgId, search),
    queryFn: ({ pageParam = 0, signal }) =>
      getBeneficiaryRepository().getBeneficiaries(
        {
          search: search || undefined,
          limit: pageSize,
          offset: pageParam,
        },
        signal,
      ),
    initialPageParam: 0,
    getNextPageParam: (lastPage, _allPages, lastPageParam) =>
      lastPage.beneficiaries.length === pageSize ? lastPageParam + pageSize : undefined,
    enabled: enabled && !!orgId,
  });
};
